import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import PhysicalExperiencesForm from './PhysicalExperiencesForm'

const PhysicalExperienceEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <PhysicalExperiencesForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default PhysicalExperienceEdit
